import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { ResponsePackage } from "../models/util.model";
import { Observable } from "rxjs";
import { F11CrudCreate } from "../models/feeder11.model";

@Injectable({
  providedIn: 'root',
})
export class Feeder11Service {
    private pathApi: string;
    constructor(private http: HttpClient, private config: AppConfig){
        this.pathApi = this.config.setting['pathApi'] + 'feeder11/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getAllForSelect(utilityId: number | null = null): Observable<any> {
    if(utilityId) {
      return this.http.get(`${this.pathApi}getAllForSelect/${utilityId}`, {observe: 'response'});
    }
    else {
      return this.http.get(`${this.pathApi}getAllForSelect`, {observe: 'response'});
    }
  }

    getAll(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}getAll`, dataIn, {observe: 'response'});
    }

    save(f11: F11CrudCreate): Observable<any> {
        return this.http.post(`${this.pathApi}save`, f11, {observe: 'response'});
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${this.pathApi}delete/${id}`, {observe: 'response'});
    }
    

    download(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}downloadFile`, dataIn);
    }

    getV3FeederStats(dataIn: any): Observable<any> {
      return this.http.post(`${this.pathApi}getV3FeederStats`, dataIn, { headers: this.headers, observe: 'response'});
    }
}